import axios from 'axios';
import { useState } from 'react';
import apiClient from 'services/_infra/apiClient';

export function useSendRecording() {
  const [uploadProgress, setUploadProgress] = useState(null);

  const sendRecording = async (file, fileName, type, override) => {
    // console.log("Sending recording:", file, fileName, type, override);
    setUploadProgress(0);
    const res = await SendRecording(file, fileName, type, override, setUploadProgress);

    // console.log("Res from server:", res, !res, !res.status, res.status !== 200);

    if (!res || !res.status || res.status !== 200) {
      // console.log("Clearing upload progress");
      setUploadProgress(null);
    } else setUploadProgress(1);

    return res;
  };

  const clearProgress = () => setUploadProgress(null);

  return { uploadProgress, clearProgress, sendRecording };
}

export async function SendRecording(file, fileName, type, override = false, onProgress = () => {}) {
  const formData = new FormData();
  formData.append('audio', file, `${fileName}.${type}`);
  formData.append('override', override);

  const url = `${process.env.PUBLIC_API_URL}/uploadCameraAudio`;

  try {
    const response = await axios.post(url, formData, {
      onUploadProgress: (evt) => {
        onProgress(evt.progress);
      },
    });

    onProgress(1);
    return response;
  } catch (error) {
    console.error('Error in SendRecording:', error);
    return error;
  }
}

export async function GetAudios(deviceId) {
  if (typeof deviceId !== 'number') return;

  const audios = await apiClient.get(`/getCameraAudio/${deviceId}`);
  return audios?.data?.clips || [];
}

export async function UpdateAudio(audioId, deviceIds) {
  if (!deviceIds) return null;
  if (!audioId || typeof audioId !== 'number') return null;

  return await apiClient.post(`/updateCameraAudioDevices`, {
    audioId,
    deviceIds,
  });
}

export async function SaveTempAudio(toDelete, override) {
  return await apiClient.post(`/setTempCameraAudio`, {
    toDelete,
    override,
  });
}

export async function DeleteAudio(audioIds) {
  if (!audioIds || audioIds?.length < 1) return null;

  return await apiClient.delete(`/deleteAudio`, {
    audioIds,
  });
}

export async function EditAudio(audioId, fileName) {
  if (!audioId || typeof audioId !== 'number') return;
  if (!fileName || typeof fileName !== 'string') return;

  return await apiClient.put(`/UpdateCameraAudioInfo`, {
    audioId,
    fileName,
  });
}
